import React, { useState } from 'react';
import { FiHeadphones, FiHelpCircle } from 'react-icons/fi';
import help from './img/help.svg';
import { SubmenuWrapper, SubmenuHeader, SubmenuImage, SubmenuTitle, SubmenuSubtitle, SubmenuBody, SubmenuNav, SubmenuList, SubmenuItem, SubmenuLinkContent, SubmenuLinkTitle, SubmenuLinkDescription, SubmenuIcon, SubmenuLink } from './submenu';
import { MenuArrow, MenuIcon, MenuItem, MenuLabel, MenuLink } from './menu';

export function MenuItemHelp() {
  const [isExpanded, setIsExpanded] = useState(false);

  const appName = process.env.REACT_APP_NAME;

  const platformSupportUrl = process.env.REACT_APP_SUPPORT_LINK;
  let supportUrl;

  switch (appName) {
    case 'encceja':
      supportUrl = 'https://suportecanaleducacao.zendesk.com/hc/pt-br/requests/new';
      break;
    case 'pit':
      supportUrl = 'https://pitcanaleducacao.zendesk.com/hc/pt-br/requests/new';
      break;
    case 'maiseducacao':
      supportUrl = 'https://suportemaisformacao.zendesk.com/hc/pt-br/requests/new';
      break;
    case 'canaleducacao':
      supportUrl = 'https://suportecanaleducacao.zendesk.com/hc/pt-br/requests/new';
      break;
    case 'egepi':
      supportUrl = 'https://escoladegoverno.zendesk.com/hc/pt-br/requests/new';
      break;
    default:
      supportUrl = 'https://suporte-plataforma.zendesk.com/hc/pt-br/requests/new';
  }

  const handleShowSubmenu = e => {
    e.stopPropagation();
    setIsExpanded(!isExpanded);
  };

  return (
    <MenuItem
      hasSubmenu
      isExpanded={isExpanded}
    >
      <MenuLink onClick={handleShowSubmenu}>
        <span>
          <MenuIcon>
            <FiHelpCircle />
          </MenuIcon>{' '}
          <MenuLabel>Precisa de ajuda?</MenuLabel> <MenuArrow isExpanded={isExpanded} />
        </span>
      </MenuLink>

      <SubmenuWrapper className="c-submenu">
        <SubmenuHeader>
          <SubmenuImage
            src={help}
            alt=""
          />
          <SubmenuTitle>Precisa de ajuda?</SubmenuTitle>
          <SubmenuSubtitle>Nosso time está pronto para te auxiliar </SubmenuSubtitle>
        </SubmenuHeader>

        <SubmenuBody>
          <SubmenuNav>
            <SubmenuList>
              {platformSupportUrl && (
                <SubmenuItem>
                  <SubmenuLink asChild>
                    <a
                      href={platformSupportUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <SubmenuIcon>
                        <FiHelpCircle />
                      </SubmenuIcon>
                      <SubmenuLinkContent>
                        <SubmenuLinkTitle>Perguntas frequentes</SubmenuLinkTitle>
                        <SubmenuLinkDescription>Canal de consulta e manuais de uso da plataforma</SubmenuLinkDescription>
                      </SubmenuLinkContent>
                    </a>
                  </SubmenuLink>
                </SubmenuItem>
              )}
              <SubmenuItem>
                <SubmenuLink asChild>
                  <a
                    href={supportUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <SubmenuIcon>
                      <FiHeadphones />
                    </SubmenuIcon>
                    <SubmenuLinkContent>
                      <SubmenuLinkTitle>Suporte</SubmenuLinkTitle>
                      <SubmenuLinkDescription>Fale conosco</SubmenuLinkDescription>
                    </SubmenuLinkContent>
                  </a>
                </SubmenuLink>
              </SubmenuItem>
            </SubmenuList>
          </SubmenuNav>
        </SubmenuBody>
      </SubmenuWrapper>
    </MenuItem>
  );
}
